import React,{useEffect} from 'react'
import './index.scss'
import phonebanner from '@/assets/images/phonebanner.png'
import {connect} from 'react-redux'
import ForddTopTit from '@/components/forddtopt'
import {setTit} from '@/utils/settit'
const mapStateToProps = (state) => ({
  tenant : state.getIn(['tenantReducer','tenant'])
})
const PPrivacy = (props) => {
  // let {tenant} = props
  useEffect(() => {
    document.title = `「${setTit()}」 隐私保护`
    return () => {
      document.title = ''
    }
  }, [])
  return (
    <div className="pprivacy__box">
      {/* <p className="top-title">本次服务由「{tenant}」为您提供</p> */}
      <ForddTopTit/>
      <div className="pprivacy-show">
        <img className="phone-banner" src={phonebanner} alt="" />
        <div className="text-show">
          <div className="text-list-box">
            <h3>号码加密，通过“虚拟中间号”联系车主</h3>
            <div>每个订单的虚拟中间号均不相同，保证司机、乘客手机号互不可见</div>
          </div>
          <div className="text-list-box">
            <h3>订单支付30分钟后，号码保护失效</h3>
            <div>虚拟中间号失效后，司机、乘客之间不能再互相联系，避免个人号码泄露，充分保障用户隐私</div>
          </div>
          <div className="text-info">注：受运营商服务和网络环境限制，号码保护服务可能出现不稳定的情况</div>
        </div>
      </div>
    </div>
  )
}
export default connect(mapStateToProps)(PPrivacy)
